module.exports = "/_next/static/images/Cable-7db8bd7d5f8c5d2b7c90ef52ed9b2142.png";